module.exports = __webpack_public_path__ + "assets/img/1ee3864c2defb6c13d9547b0df2c6db3.png";